<template>
  <div class="BigHolder">
    <div class="TitleHolder">
      <h1>Reaction Timer</h1>
    </div>
    <div class="holder" @click.self="CancelClick">
      
      <div v-if="this.showButton">
        <button @click="TriggerTest">Play</button>
      </div>
      <div v-if="this.showTest">
        <PopUp @Clicked="FinishTest" :StartTime="this.StartTime">
          <h1>Click Me!</h1>
        </PopUp>
      </div>  
      <div v-if="this.showResults">
        <OutputComp :DisplayData="this.result"/>
      </div>
    </div>
  </div>
  
  
</template>

<script>
import OutputComp from './components/OutputComp.vue';
import PopUp from "./components/PopUp.vue";

export default {
  name: 'App',
  components: {
    PopUp,
    OutputComp
  },
  data:function
    OutputComp(){
    return { 
      showButton:true,
      showTest:false,
      showResults:false,
      StartTime:null,
      result:null,
      CallBack:0
    }
  },
  methods:{
    TriggerTest: function(){
      this.showResults = false;
      this.showTest = false;
      this.showButton = false;
      this.CallBack = setTimeout(this.ShowTest,2000)
    },

    CancelClick:function(){
      if (!this.showButton)
      {
        clearInterval(this.CallBack);
        this.showButton = true;
        alert("Premature Click")
      }
      
    },

    ShowTest:function(){
      this.showTest = true;
      this.StartTime = new Date();
    },

    FinishTest:function(Value){
      //alert(Value)
      this.showTest = false;
      this.showButton = true;
      this.showResults = true;
      // console.log(Value)
      this.result = Value;
      // this.result = 900
    }
  }
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }

  body{
    background-color: #232323;
    color: white;
    
  }

  .holder{
    height: 100%;
    display: flex;
    padding: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .holder h1{
    font-size: xx-large;
  }

  .holder button{
    margin: 30px;
    padding: 40px;
    color:white ;
    background-color: #565656;
    font-size: 30px;
    border-radius: 20px;
    transition: 0.5s;
  }

  .holder button:hover{
    background: #787878;
    border-color: white;
    box-shadow: 0 0 0 4px cornsilk;
  }

  .TitleHolder{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5vh;
    background-color: rgb(44, 70, 61);
  }

  .BigHolder{
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
</style>
